import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosAPI from "../../api/axiosAPI";

//============ add testimonial ===================//
export const addTestimonial = createAsyncThunk("addTestimonial", async (data) => {
    try {
        const response = await axiosAPI.post("/add-testimonial", data)
        return response
    } catch (err) {
        return err
    }
})

//========= Get all testimonial with pagination ================//
export const getAllTestimonial = createAsyncThunk("getAllTestimonial", async ({ page, limit, search }) => {
    try {
        const response = await axiosAPI.get(`/get-all-testimonials?page=${page}&limit=${limit}&search=${search}`);
        return response;
    } catch (err) {
        return err
    }
});

//============ Get single testimonial ===================//
export const getTestimonial = createAsyncThunk("getTestimonial", async (id) => {
    try {
        const response = await axiosAPI.get(`/get-testimonial/${id}`);
        return response;
    } catch (err) {
        return err
    }
});

//============ Get all testimonial count ===================//
export const getAllTestimonialCount = createAsyncThunk("getAllTestimonialCount", async () => {
    try {
        const response = await axiosAPI.get("/all-testimonial-count");
        return response;
    } catch (err) {
        return err
    }
});

//============ Get all inactive testimonial ===================//
export const getInActiveTestimonial = createAsyncThunk("getInActiveTestimonial", async () => {
    try {
        const response = await axiosAPI.get("/get-inactive-testimonial");
        return response;
    } catch (err) {
        return err
    }
});

//============ Get all active testimonial ===================//
export const getActiveTestimonial = createAsyncThunk("getActiveTestimonial", async () => {
    try {
        const response = await axiosAPI.get("/get-active-testimonial");
        return response;
    } catch (err) {
        return err
    }
});

//============== Toggle testimonial status ==============//
export const toggleTestimonialStatus = createAsyncThunk("toggleTestimonialStatus", async (data) => {
    try {
        const { id } = data;
        const response = await axiosAPI.put(`/toggle-testimonial-status/${id}`);
        return response;
    } catch (err) {
        return err
    }
})

//=============== update brand =================//
export const updateTestimonial = createAsyncThunk("updateTestimonial", async (data) => {
    try {
        const { id, values } = data;
        const response = await axiosAPI.put(`/update-testimonial/${id}`, values);
        return response
    } catch (err) {
        return err
    }
})